// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

export const InfoDetail = ({ label, value }) => (
  <div className='slds-grid slds-m-bottom_xx-small'>
    <div className='u-font-size-larger slds-size_1-of-2'>
      {label}
    </div>
    <div>
      {value}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/loanapplication-info/InfoDetail.js